import { Component, OnDestroy, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, UntypedFormControl, FormArray, Validators, FormControl } from '@angular/forms';
import { MultiInputStepComponent } from '../../step/multi-input-step/multi-input-step.component';
import { environment } from '../../../../environments/environment';
import { Rate } from '../../../../../../shared/rate.model';
import { resolveEffectiveRateBucket } from '../../../../../../services/advertised-rate-context';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-phone',
    templateUrl: './phone.component.html',
    styleUrls: ['./phone.component.scss', '../../step/step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class PhoneComponent extends MultiInputStepComponent implements OnInit, OnDestroy {
  
  @ViewChild('phone') phoneField: ElementRef;
  @ViewChild("lenderList") lenderList: ElementRef;
  
  public title: string = "Enter your phone number and you're all done!";
  public experiment: boolean;
  public subtitle: string = "Complete This Final Step To Get Rates & Calculate Payment";
  public notDebtSettlement: boolean;
  public submitButtonText: string = 'Get My Rates';
  public finalLenders: any;
  public jornaya: boolean = false;
  isPreferBox = false;
  canEditScores: boolean = false;
  showLenderError: boolean = false;
  private advertisedRateWarningLogged: boolean = false;
  private effectiveAdvertisedRate: Rate | null = null;
  private effectiveRateSubscription: Subscription | null = null;

  fruLocalKiosk: boolean;
  fruLocal: boolean;

  phoneMask: Object = {
    mask: '(#00) 000-0000',
    definitions: {'#': /[2-9]/}
  };

  // Not sure about all parameters but it give error and break phone
  // when I try to edit phone number
  // phoneMask: Object = {
  //   mask: [
  //     {
  //       mask: /^$/i,
  //       lazy: true
  //     },
  //     {
  //       mask: '(#00) 000-0000',
  //       definitions: {'#': /[1-9]/},
  //       lazy: false
  //     }
  //   ]
  // }

  ngOnInit() {
    this.fruLocalKiosk = this.communication.fruLocalKiosk;
    // Phone validation
    const phoneControl = this.form.contains('phoneNumber')
      ? this.form.get('phoneNumber') as UntypedFormControl
      : new UntypedFormControl('');
    phoneControl.setValidators([Validators.required, Validators.pattern(/(\((?!000|111|200|222|300|333|400|444|500|555|600|666|700|777|900|999)\d{3}\) \d{3}-\d{4})|\d{10}/)]);
    phoneControl.updateValueAndValidity();
    this.controls.push(phoneControl);
    // SMS validation
    this.controls.push(this.form.contains('sms') ? this.form.get('sms') as UntypedFormControl : new UntypedFormControl(false));
    // Email Preference
    this.controls.push(this.form.contains('email_preference') ? this.form.get('email_preference') as UntypedFormControl : new UntypedFormControl(false));
    // Spanish Preference
    this.controls.push(this.form.contains('prefers_spanish') ? this.form.get('prefers_spanish') as UntypedFormControl : new UntypedFormControl(false));

    if (!this.form.contains('phoneNumber')) { this.form.addControl('phoneNumber', this.controls[0]); }
    if (!this.form.contains('sms')) { this.form.addControl('sms', this.controls[1]); }
    if (!this.form.contains('email_preference')) { this.form.addControl('email_preference', this.controls[2]); }
    if (!this.form.contains('prefers_spanish')) { this.form.addControl('prefers_spanish', this.controls[3]); }
    // FRU-21436: new "100% digital" contact preference.
    if (!this.form.contains('prefers_digital')) { this.form.addControl('prefers_digital', new UntypedFormControl(false)); }

    this.analyticsService.getExperiments().subscribe(
      (variationData: any) => {
        if (variationData.enabledVariations.hasOwnProperty('prefBoxes')) {
          this.isPreferBox = true;
        }
      }
    );

    this.isFullFastFlow = new URLSearchParams(window.location.search).get('fast_variant') === 'yes';

    if (!environment.production) {
      this.canEditScores = true;
      if (this.randomService.fillEnabled) {
        this.form.controls.phoneNumber.setValue(this.randomService.consumer.phoneNumber.toString());
      }
      this.form.addControl('phonescore_override', new FormControl());
      this.form.addControl('emailscore_override', new FormControl());
    }

    if (this.fruHttpService.effectiveAdvertisedRatesEnabled()) {
      const qp = new URLSearchParams(window.location.search);
      const bucket = resolveEffectiveRateBucket({
        type: (this.form.get('type') && this.form.get('type').value) || qp.get('type'),
        loanPurpose: (this.form.get('loanPurpose') && this.form.get('loanPurpose').value)
          || qp.get('LoanPurpose') || qp.get('loanPurpose') || qp.get('loanpurpose'),
        formType: (this.form.get('formType') && this.form.get('formType').value)
          || qp.get('FormType') || qp.get('formType'),
        lpButton: (this.form.get('lp_button') && this.form.get('lp_button').value) || qp.get('lp_button'),
        pageType: (this.brandService && this.brandService.data && this.brandService.data.pageType) || '',
        program: this.fruHttpService.effectiveAdvertisedRateProgram(),
      });
      // A generic phone-step entry has no truthful reviewed product identity;
      // it intentionally fails closed instead of borrowing the opening default.
      if (bucket) {
        this.effectiveRateSubscription = this.fruHttpService.getRateFinderRates(bucket)
          .subscribe(rate => { this.effectiveAdvertisedRate = rate; });
      } else {
        this.effectiveAdvertisedRate = null;
        this.fruHttpService.clearEffectiveAdvertisedRateScope();
      }
    }
  }

  ngOnDestroy(): void {
    if (this.effectiveRateSubscription) {
      this.effectiveRateSubscription.unsubscribe();
      this.effectiveRateSubscription = null;
    }
  }

  submit() {
    super.submit();
  }

  focusControl(name: string) {
    const els = Array.from(document.querySelectorAll('[formcontrolname="' + name + '"]')) as HTMLElement[];
    const el = els.find(e => (e as any).offsetParent !== null) || els[0];
    if (el) { setTimeout(() => el.focus(), 0); }
  }

  private enableFullFastFlowControls(): void {
    if (this.form.controls.firstName) {
      return;
    }

    const firstNameCtrl = new UntypedFormControl('', [Validators.required, Validators.minLength(2)]);
    const lastNameCtrl = new UntypedFormControl('', [Validators.required, Validators.minLength(2)]);
    const emailCtrl = new UntypedFormControl('', [Validators.required, Validators.email]);
    this.form.addControl('firstName', firstNameCtrl);
    this.form.addControl('lastName', lastNameCtrl);
    this.form.addControl('email', emailCtrl);
    this.controls.push(firstNameCtrl, lastNameCtrl, emailCtrl);
  }

  private get advertisedRate(): string | null {
    if (this.fruHttpService.effectiveAdvertisedRatesEnabled()) {
      return this.effectiveAdvertisedRate
        && this.effectiveAdvertisedRate.status === 'ok'
        && typeof this.effectiveAdvertisedRate.display_rate === 'string'
        && typeof this.effectiveAdvertisedRate.display_apr === 'string'
        ? `${this.effectiveAdvertisedRate.display_rate}% (${this.effectiveAdvertisedRate.display_apr}% APR*)`
        : null;
    }
    if (environment.advertisedRate) {
      return environment.advertisedRate;
    }

    if (!this.advertisedRateWarningLogged) {
      console.error('Missing environment.advertisedRate; using fallback rate display.');
      this.advertisedRateWarningLogged = true;
    }

    return 'current advertised rates';
  }


  get closing(): { headline: string; checks: string[]; compareNote: string; valuesNote: string; veteranThankYou: string; cta: string } {
    const RATE = this.advertisedRate;
    const _p = new URLSearchParams(window.location.search);
    const kw = [_p.get('utm_keyword'), _p.get('utm_term'), _p.get('utm_campaign'), _p.get('utm_content'), _p.get('utm_adgroup'), _p.get('adgroup')].filter(Boolean).join(' ').toLowerCase();
    const type = ((this.form.get('type') && this.form.get('type').value) || '').toString().toLowerCase();
    const formType = ((this.form.get('formType') && this.form.get('formType').value) || '').toString().toLowerCase();
    const cashOutVal = Number((this.form.get('cashOut') && this.form.get('cashOut').value) || 0);
    const propVal = Number((this.form.get('propertyValue') && this.form.get('propertyValue').value) || 0);
    const money = (v: number): string => v >= 1000000 ? '$' + (Math.round(v / 100000) / 10) + 'M' : '$' + Math.round(v / 1000) + 'k';
    const cash = cashOutVal >= 1000 ? money(cashOutVal) : '';
    const cashReason = ((this.form.get('cashOutReason') && this.form.get('cashOutReason').value) || '').toString().toLowerCase();
    const vet = ['yes', 'y', 'true', '1'].indexOf(((this.form.get('veteranMilitary') && this.form.get('veteranMilitary').value) || '').toString().toLowerCase()) > -1;
    const isCashout = formType.indexOf('cashout') > -1 || (cashOutVal >= 1000 && type !== 'purchase');
    const isHeloc = formType.indexOf('heloc') > -1;
    const isHomeImp = formType.indexOf('homeimprovement') > -1;
    let headline = 'Lower payment, locked in.';
    let typeLabel = 'Rate and term refinance';
    if (isCashout) {
      if (cashReason === 'reduce-debt') { headline = cash ? `Knock out high-interest debt with your ${cash}.` : 'Knock out your high-interest debt.'; }
      else if (cashReason === 'home-improvement') { headline = cash ? `Fund your home project with ${cash}.` : 'Fund your home project.'; }
      else if (cashReason === 'emergency') { headline = cash ? `Your ${cash} is one tap away.` : 'Get the cash you need, fast.'; }
      else { headline = cash ? `You're one tap from your ${cash}.` : `You're one tap from your cash.`; }
      typeLabel = 'Cash-out refinance';
    }
    else if (isHeloc) { headline = 'Your equity is ready to work.'; typeLabel = 'Home equity line'; }
    else if (isHomeImp) { headline = 'Fund your project the smart way.'; typeLabel = 'Home improvement loan'; }
    else if (type === 'purchase') { headline = "You're one tap from real purchase numbers."; typeLabel = 'Home purchase'; }
    if (!isCashout && !isHeloc && !isHomeImp && type !== 'purchase' && kw) {
      if (/debt|consolidat/.test(kw)) { headline = 'Consolidate your debt and simplify.'; }
      else if (/lower|reduce|payment/.test(kw)) { headline = 'Lower your monthly payment.'; }
      else if (/veteran|va loan|va refinance|va mortgage/.test(kw)) { headline = 'Put your VA benefit to work.'; }
      else if (/rate/.test(kw)) { headline = 'Lock in a lower rate.'; }
    }
    let compareNote = '';
    if (isCashout) { compareNote = 'Prefer home equity instead? You can compare those too.'; }
    else if (isHeloc) { compareNote = 'Want to compare other options? You can see those too.'; }
    const checks: string[] = [typeLabel];
    if (cash) { checks.push('Estimated ' + cash + ' cash out *'); }
    if (propVal >= 1000) { checks.push('Estimated ' + money(propVal) + ' home value *'); }
    const cta = RATE
      ? 'Get your best rates and options as low as ' + RATE + '. No obligation, no credit pull.'
      : 'Get your current rates and options. No obligation, no credit pull.';
    const valuesNote = (cash || propVal >= 1000) ? "* Don't worry, these are just estimates for purposes of getting your rates. You can change them after." : '';
    const veteranThankYou = vet ? '🇺🇸 Thank you for your service. 🫡' : '';
    return { headline: headline, checks: checks, compareNote: compareNote, valuesNote: valuesNote, veteranThankYou: veteranThankYou, cta: cta };
  }

  get closingMessage(): string {
    const RATE = this.advertisedRate;
    const type = ((this.form.get('type') && this.form.get('type').value) || '').toString().toLowerCase();
    const formType = ((this.form.get('formType') && this.form.get('formType').value) || '').toString().toLowerCase();
    const cashOutVal = Number((this.form.get('cashOut') && this.form.get('cashOut').value) || 0);
    const money = (v: number): string => v >= 1000000 ? '$' + (Math.round(v / 100000) / 10) + 'M' : '$' + Math.round(v / 1000) + 'k';
    const cash = cashOutVal >= 1000 ? money(cashOutVal) : '';
    if (formType.indexOf('cashout') > -1 || (cashOutVal >= 1000 && type !== 'purchase')) {
      if (!RATE) {
        return cash
          ? `You're one tap from your ${cash}. Compare current cash-out options from competing lenders. Tap Get My Rates. No obligation, no credit pull.`
          : `You're one tap from your cash. Compare current cash-out options from competing lenders. Tap Get My Rates. No obligation, no credit pull.`;
      }
      return cash
        ? `You're one tap from your ${cash}. Rates are as low as ${RATE} right now, and lenders compete for your loan so you see the best offers side by side. Tap Get My Rates. No obligation, no credit pull.`
        : `You're one tap from your cash. Rates are as low as ${RATE} right now, and lenders compete for your loan. Tap Get My Rates. No obligation, no credit pull.`;
    }
    if (formType.indexOf('heloc') > -1) {
      if (!RATE) { return 'Your equity is ready to work. Tap Get My Rates to compare current HELOC options, with no credit pull.'; }
      return `Your equity is ready to work. Tap Get My Rates for HELOC offers as low as ${RATE} from competing lenders, in seconds, with no credit pull.`;
    }
    if (formType.indexOf('homeimprovement') > -1) {
      if (!RATE) { return 'Fund your project the smart way. Compare current home improvement loan options. Tap Get My Rates. No obligation, no credit pull.'; }
      return `Fund your project the smart way. Rates are as low as ${RATE}, and lenders compete for your home improvement loan. Tap Get My Rates. No obligation, no credit pull.`;
    }
    if (type === 'purchase') {
      if (!RATE) { return `You're one tap from real purchase numbers. Compare current options from lenders competing for your loan. Tap Get My Rates. No obligation, no credit pull.`; }
      return `You're one tap from real purchase numbers. See rates as low as ${RATE} from lenders competing for your loan. Tap Get My Rates. No obligation, no credit pull.`;
    }
    if (!RATE) { return 'Lower payment, locked in. Compare current refinance options from competing lenders. Tap Get My Rates. Takes 10 seconds.'; }
    return `Lower payment, locked in. Rates are as low as ${RATE} today, and lenders compete to beat your current rate. Tap Get My Rates. Takes 10 seconds.`;
  }

  initStep() {
    setTimeout(() => this.phoneField.nativeElement.focus(), 0);

    this.lenders.subscribe((lenders) => {
      if (lenders.length > 0) {
        this.finalLenders = lenders;
        setTimeout(() => {
          this.jornaya = true;
          this.checkLenders();
        }, 150);
      }
    });
  }

  checkLenders() {
    //Because jornaya apparently can't register the prechecked boxes after all
    //Need to load the opposite checked type for the lender then click it with js
    let element : any = this.lenderList.nativeElement;
    let checkboxes : any = element.querySelectorAll('input');
    checkboxes.forEach((checkbox) => {
      checkbox.click();
    });
    this.snap();
  }

  prefersSpanishSelected () {
    this.analyticsService.trackGoal(26);
    console.log('goal tracked');
    this.snap();
  }

  closeModal() {
    this.communication.modalClosed.emit(true);
  }

  phoneChange($event) {
    this.snap();
    this.checkPhoneLength($event.target.value);
  }

  phoneInput($event) {
    this.checkPhoneLength($event.target.value);
  }

  checkPhoneLength(value: string) {
    if(value.length >= 4) {
      this.communication.setShouldSetDefaultSelected(true);
    }
  }

  onCheckChange(event) {
    this.snap();
    this.showLenderError = false;

    let lenderUp = [];
    const lenderList: FormArray = this.form.get('lendersList') as FormArray;
    lenderList.controls.forEach((ctrl: UntypedFormControl) => {
      if (event.target.value == ctrl.value.id) {
        if (event.target.checked) {
          ctrl.value.checked = true;
        } else {
          ctrl.value.checked = false;
        }
      }
      lenderUp.push(ctrl.value);
    });

    while (lenderList.length !== 0) {
      lenderList.removeAt(0)
    }

    lenderUp.forEach((lender) => {
      lenderList.push(new UntypedFormControl(lender));
    });

    let i: number = 0;
    const lenderArray: FormArray = this.form.get('lenders') as FormArray;
    if(event.target.checked){
      lenderArray.push(new UntypedFormControl(event.target.value));
    } else {
      let i: number = 0;
      lenderArray.controls.forEach((ctrl: UntypedFormControl) => {
        if(ctrl.value == event.target.value) {
          lenderArray.removeAt(i);
          return;
        }

        i++;
      });
    }

    if (!this.validateLenders() && this.isUncheckedValidation) {
      this.showLenderError = true;
    }
  }

  onCheckChangeTop(event) {
    // this.snap();
    if(event.target.checked) {

    } else {
      this.analyticsService.trackGoal(47);
    }
  }

  reInitLenderList() {
    const lenderArray: FormArray = this.form.get('lenders') as FormArray;
    const lenderList: FormArray = this.form.get('lendersList') as FormArray;
    while (lenderArray.length !== 0) {
      lenderArray.removeAt(0)
    }
    while (lenderList.length !== 0) {
      lenderList.removeAt(0)
    }

    this.finalLenders.forEach(value => {
      if (value.checked) {
        lenderArray.push(new UntypedFormControl(value?.id));
      }
      lenderList.push(new UntypedFormControl(value));
    });
  }

  phoneSubmit(isNeedLenderValidation) {
    if (isNeedLenderValidation) {
      if (this.validateLenders()) {
        this.submit();
      } else {
        this.showLenderError = true;
      }
    } else {
      this.submit()
    }
  }

  validateLenders() {
    let is_valid = false;
    const lenderList: FormArray = this.form.get('lendersList') as FormArray;
    lenderList.controls.forEach((ctrl: UntypedFormControl) => {
      if (ctrl.value.checked) {
        is_valid = true;
      }
    });

    return is_valid;
  }

  trackAndNavigate(event: Event, goalID: number) {
    event.preventDefault();
    const url = (event.currentTarget as HTMLAnchorElement).href;

    this.analyticsService.trackGoal(goalID);
    setTimeout(() => window.open(url, '_blank', 'noopener,noreferrer'), 100);
  }
}
